module.exports = __webpack_public_path__ + "static/media/trimex_hojaoro.01f9fd88.png";